// extracted by mini-css-extract-plugin
export default {"option-item-title":"QDCI6_option-item-title"};